import * as React from 'react';
import { route } from '../../utils/route';
import { trackSignupClicked } from '../../utils/tracking';

interface FinalCTAProps {
  loginUrl: string;
  whatsappUrl: string;
}

export function FinalCTA({}: FinalCTAProps) {
  return (
    <section className="ong-final-cta">
      <style>{`
        .ong-final-cta {
          padding: 80px 24px;
          background: #1a1a1a;
          text-align: center;
        }
        .ong-final-inner {
          max-width: 640px;
          margin: 0 auto;
        }
        .ong-final-cta h2 {
          font-size: 28px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 12px;
        }
        .ong-final-cta p {
          font-size: 18px;
          color: rgba(255,255,255,0.75);
          margin: 0 0 36px;
        }
        .ong-final-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        @media (max-width: 640px) {
          .ong-final-cta {
            padding: 60px 24px;
          }
          .ong-final-cta h2 {
            font-size: 24px;
          }
          .ong-final-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .ong-final-ctas a {
            justify-content: center;
          }
        }
      `}</style>
      <div className="ong-final-inner">
        <h2>Tu misión es transformar vidas. La nuestra, que no te falte nada para hacerlo.</h2>
        <p>Empezá a recibir frutas y verduras frescas con la calidad y formalidad que tu organización necesita.</p>
        <div className="ong-final-ctas">
          <a href={route('wholesale.pricing')} className="ong-btn-primary">
            <i className="fa fa-list-alt" /> Ver Precios Mayoristas
          </a>
          <a href={route('company.create')} className="ong-btn-secondary" onClick={() => trackSignupClicked('organizaciones-sociales', 'footer')}>
            <i className="fa fa-user-plus" /> Crear una cuenta
          </a>
        </div>
      </div>
    </section>
  );
}
